import { CandidatePriority } from '@pflegia/types/api/candidate/candidate-priority';

/**
 * Returns all job titles which have the highest priority among the elements.
 * If there are multiple job titles with the same/similar highest priority, they will all be returned.
 */
export const getHighestPriorityJobTitles = <T extends { trackingPriority: CandidatePriority }>(
  jobTitles: T[],
  includeSimilarPriorities = false,
) =>
  jobTitles.reduce((accumulator, current) => {
    if (!accumulator.length) return [current];
    if (!current.trackingPriority) return accumulator;
    const [{ trackingPriority: highestPriority }] = accumulator;
    if (current.trackingPriority === highestPriority) return accumulator.concat(current);
    if (includeSimilarPriorities && current.trackingPriority[0] === highestPriority[0]) return accumulator.concat(current);

    return current.trackingPriority < highestPriority ? [current] : accumulator;
  }, [] as T[]);
